export default __webpack_public_path__ + "static/media/astronaut-gearingup.8efe25fe.jpg";